import { Link } from 'react-router-dom';

import styles from './About.module.css';

export default function About() {
  return (
    <div className={styles.about}>
      <div className={styles.container}>

       <h1>About RisingDSP</h1> 
       <p> RisingDSP is an independent audio software project focused on creating innovative and accessible tools for music production and sound design. </p> 
       <p> As a solo developer, I started RisingDSP with a simple idea: powerful sound design does not have to be complicated. My first synthesizer, WaveShape, combines multiple synthesis techniques, modulation options, and professional effects in a straightforward and creative workflow. </p> 
       <p> I put a strong focus on sound, usability, and experimentation. Every feature is designed with the goal of giving musicians and sound designers direct control without unnecessary complexity. </p> 
       <p> WaveShape is the beginning of the project. While my current focus is on developing and refining the synthesizer, I plan to continue exploring new ideas in synthesis, digital signal processing, and creative audio tools. </p> 
       <p> RisingDSP is built independently with a passion for sound and technology, with the goal of creating focused tools that are enjoyable to use and inspiring to create with. </p>

      </div>
    </div>
  );
}